import { FC } from 'react';
import { Modal, Button } from 'antd';
import SvgIcon from '@/components/SvgIcon';
import useIsMobile from '@/hooks/useIsMobile';
import styles from './index.module.scss';

export interface ConfirmModalProps {
  open: boolean;
  icon?: string;
  iconSize?: number;
  iconBgColor?: string;
  iconColor?: string;
  title: string;
  description: string;
  confirmText: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonSize?: 'small' | 'middle' | 'large';
  showCancelButton?: boolean;
  cancelButtonClassName?: string;
  confirmDisabled?: boolean;
  mobileButtonLayout?: 'horizontal' | 'vertical';
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  icon = 'warning',
  iconSize = 76,
  iconBgColor = 'var(--yellow-10)',
  iconColor = 'var(--yellow-100)',
  title,
  description,
  confirmText,
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  confirmButtonSize = 'large',
  showCancelButton = true,
  cancelButtonClassName = 'btn-secondary',
  confirmDisabled = false,
  mobileButtonLayout = 'horizontal',
}) => {
  const isMobile = useIsMobile();

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={isMobile ? 'calc(100vw - 48px)' : 400} className={styles.confirmModal} closeIcon={<SvgIcon name="x-black" size={16} />}>
      <div className={styles.confirmModalContent}>
        <div className={styles.confirmModalIcon} style={{ background: iconBgColor }}>
          <SvgIcon name={icon} size={iconSize} style={{ color: iconColor }} />
        </div>
        <h3 className={styles.confirmModalTitle}>{title}</h3>
        <p className={styles.confirmModalDesc}>{description}</p>
        <div className={`${styles.confirmModalButtons} ${!showCancelButton ? styles.singleButton : ''} ${isMobile && mobileButtonLayout === 'horizontal' ? styles.horizontalLayout : ''}`}>
          {showCancelButton && (
            <Button className={cancelButtonClassName} onClick={onCancel}>
              {cancelText}
            </Button>
          )}
          <Button size={confirmButtonSize} type="primary" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
